import Typography, { TypographyProps } from '@mui/material/Typography'
import { styled, CSSObject } from '@mui/material/styles'
import { VoucherBannerVariant } from '../../VoucherBanner.types'

const BaseTypography = Typography as React.ComponentType<
  Omit<TypographyProps, 'variant'>
>

const GRADIENTS: Record<VoucherBannerVariant, string> = {
  smava: 'linear-gradient(270deg, #1B5426 0%, #277634 100%)',
  ffg: 'linear-gradient(270deg, #0D315B 0%, #165297 100%)'
}

export const BannerContainer = styled('div')<{
  clickable?: boolean
  variant: VoucherBannerVariant
}>(({ theme, clickable, variant }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(2, 2),
  borderRadius: 0,
  background: GRADIENTS[variant],
  color: '#fff',
  overflow: 'hidden',
  minHeight: 80,
  cursor: clickable ? 'pointer' : 'default'
}))

export const Illustration = styled('img')<{
  variant: VoucherBannerVariant
}>(({ theme, variant }) => {
  const baseStyle: CSSObject = {
    position: 'absolute',
    right: -10,
    bottom: -15,
    height: '155%',
    pointerEvents: 'none'
  }
  if (variant === 'ffg') {
    return {
      ...baseStyle,
      height: 'auto',
      width: 161,
      right: 0,
      bottom: -31,
      transform: 'rotate(-4deg)',
      transition: 'opacity 0.3s ease',
      [theme.breakpoints.down('sm')]: {
        opacity: 0.2
      }
    }
  }
  return baseStyle
})

export const Title = styled(BaseTypography, {
  shouldForwardProp: (prop) => prop !== 'variant'
})<{ variant: VoucherBannerVariant }>(({ variant }) => ({
  fontWeight: 900,
  fontSize: '28px',
  color: '#fff',
  textAlign: 'left',
  lineHeight: '28px',
  position: 'relative',
  zIndex: 1,
  ...(variant === 'ffg' && { fontFamily: "'Lato', sans-serif" })
}))

export const Subtitle = styled(BaseTypography, {
  shouldForwardProp: (prop) => prop !== 'variant'
})<{ variant: VoucherBannerVariant }>(({ variant }) => ({
  fontWeight: 400,
  fontSize: '28px',
  lineHeight: 'normal',
  color: '#fff',
  textAlign: 'left',
  position: 'relative',
  zIndex: 1,
  ...(variant === 'ffg' && { fontFamily: "'Lato', sans-serif" })
}))

export const TextContent = styled('div')(({ theme }) => ({
  zIndex: 1,
  width: '100%',
  textAlign: 'left',
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 532,
    margin: '0 auto'
  }
}))
